<template>
    <div class="upload__container"  >
        <input type="file" ref="file" :accept="fileAcceptedTypes" @click="$event.target.value=null" hidden @change="change"/>
        <div v-if="type == 'image'" class="image__container"  @click="upload" :style="fileStyle" >
            <span v-if="!image_src" class="img__icon"><i class="far fa-image"></i></span>
            <span v-if="!image_src">Upload New Picture</span>
            <img v-if="image_src" :src="image_src" alt="">
        </div>
        <div v-if="fileName && type != 'image' " class="file_label">{{label }}<span v-if="required" class="required_mark">*</span><span class="check_mark"><i class="fas fa-check"></i></span></div>
        <div v-if="type != 'image'" class="file__container" :style="fileStyle"  >
            <span>{{fileName ? fileName : label}}<span v-if="required && !fileName" class="required_mark">*</span></span>
            <div class="file_icons">
                <span @click="upload"><i class="fas fa-upload"></i></span>
                <span class="remove" @click="remove"><i class="fas fa-times-circle"></i></span>
            </div>
        </div>
        <span v-if="upload_info" class="upload__info">{{upload_info}}</span>
        <small  v-if="fileError">{{ fileError }}</small>

    </div>
</template>

<script>
export default {
    props : {
        type : { type : String, default : "image"},
        label : { type : String, default : null},
        value : { type : [String, Object]},
        error:{ type: String, default: null },
        required : { type : Boolean, default : false},
        borderColor : { type : String, default  : "#dbdbdb"},
        accptedFormat : {type : Array | String, default : null},
        size : { type : Object, default : null}

    },

    computed  : { 
        fileStyle() {
            return {
                'border-color' : this.borderColor ? this.borderColor : this.fileError ? 'red' : "#dbdbdb" ,
                'border-width' : '1px',
                'border-style' : 'solid'
            }
        },
        fileAcceptedTypes(){
            let types = ''
            // console.log(this.accptedFormat);
            if(this.accptedFormat && this.accptedFormat.length > 0) {
                    for (let index = 0; index < this.accptedFormat.length; index++) {
                        const type = this.accptedFormat[index];
                        types += this.accptedFormat[index+1] ? `.${type}, ` : `.${type}`
                        }

            }else types = `.*`
            return types;
        },
    },
    data() {
        return  {
                // upload_info : "512x512px max, JPG or PNG and 1MB max",
                upload_info : null,
                image_src : null,
                fileName : null,
                fileError : null
        }
    },
    mounted(){
        if(this.value) {
            let fileUrl  = this.type == 'image' ? this.value.imageURL : this.value[`${this.type}URL`];
            this.toDataUrl(fileUrl, (file)=> {
                let fileName  = this.type == 'image' ? null : this.value[`${this.type}Name`];
                const dT = new ClipboardEvent('').clipboardData || 
                new DataTransfer(); 
                dT.items.add(new File([file], fileName));
                this.$refs.file.files = dT.files;
                this.ReformEmit(this.$refs.file.files[0])
                })
        }
        if(this.error) this.fileError = this.error

    },
    methods : { 
        toDataUrl(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = () => callback(xhr.response);
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        },
        change(e) { 
            this.fileError = null;
            let file = e.target.files[0]
            let fileSize = file.size 
            let fileType = file['name'].split('.').pop()
            let valid = true
            if(this.accptedFormat && !this.fileAcceptedTypes.includes(`${fileType}`)) {
                valid = false;
                this.fileError = "file type incorrect"
            }
            else if(this.size && fileSize > this.sizeToBytes({size:this.size.value, unit:this.size.unit})) {
                valid = false;
                this.fileError = "size out of limit"
            } 
            if(valid) {
                /**set true for only changed files to avoide upload all file again  */
                // let property = file.name
                // if(this.type == 'image') property = 'image'
                // else if(fileType == 'fbx') property = 'fbx'
                // else if(fileType == 'glb') property = 'glb'
                // this.$store.commit('SETFILESTATE',{[`${property}`] : true})
                // console.log("fileState in upload",this.$store.getters.getFileState);
                this.ReformEmit(file)   
            }
        },
  

        sizeToBytes(item) {
            if(item.unit == 'KB') return parseInt(item.size) * 1024
            if(item.unit == 'MG') return parseInt(item.size) * 1048576
        },
        //  bytesToSize(bytes) {
        //     var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        //     if (bytes == 0) return '0 Byte';
        //     var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        //     return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
        // },

        upload() {this.$refs.file.click()},
        remove() {
            this.fileName = null;
            this.$emit('remove')
        },
        ReformEmit(file){
            this.fileName = file.name;
            let data = {};
            let fileURL = URL.createObjectURL(file)
            if(this.type == 'image'){
                data.imageFile = file
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => this.image_src = e.target.result;
                this.$store.commit('SETEFFECTSIMAGE',data)
                console.log(data);
             }
            else {
                data[`${this.type}Name`] = file.name;
                this.type == 'file' ? data[`${this.type}`] = file : data[`${this.type}File`] = file;
                data[`${this.type}URL`]  = fileURL;
            }
            this.$emit("input", data);
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .upload__container {
        border : 1px solid transparent;
        margin : .5rem 0;
        // cursor: pointer;
        opacity: .8;
    }
    .image__container {
        background-color : #F2F3F7;;
        border-radius: .3rem;
        display : flex;
        flex-wrap: wrap;
        align-items : center;
        justify-content : center;
        height : 10rem;
        width : 100%;
        &:hover {
            opacity: .8;
            cursor: pointer;
        }
        span:first-child {
            width : 100%;
            display : flex;
            align-items : center;
            justify-content : center;
            font-size: 4rem;
            color : gray;
        }
        span:last-child {
            color : gray;
            font-size: .8rem;
            text-transform: uppercase;
        }
        img {
            width : 100%;
            height : 100%;
            object-fit: cover;
            border-radius: .3rem;
        }
    }
    .upload__info {
        width : 100%;
        font-size: .7rem;
        text-align: center;
        display : block;
        padding : .2rem 0;
        color : gray;
    }
    .file__container {
        display : flex;
        align-items : center;
        justify-content : space-between;
        border : 1px solid #E2E6F1;
        border-radius: .3rem;
        padding : .2rem .7rem;
        width : 100%;
        span:first-child{
            color:#000000b8;
            width: 10rem;
            overflow: hidden;
            white-space: nowrap;
            position: relative;
            // font-size: .9rem;
        }
    }
    .file_icons {
        span:first-child {
            color : #2D527C;
            padding : 0 .5rem;
            font-size: 1.3rem;
            transition: .3s;
            &:hover {
                cursor: pointer;
                color : #2976cd;

            }
        }
        span:last-child {
            color : #bfbfbf;
            font-size: 1.5rem;
            transition: .3s;
            &:hover {
                cursor: pointer;
                color : #ea5455;
            }
        }
        
    }
    .file_label {
        display: flex;
        align-items: center;
        position: relative;
        width : fit-content;
        span:first-child {
            right : 1.5rem;
        }
    }
    .check_mark {
        color : #3bf33b;
        padding: 0 0.5rem;
    }
      .required_mark {
        position: absolute;
        top : -.3rem;
    }
       small, .required_mark {
        color : red !important;
    }
  
</style>


// WEBPACK FOOTER //
// src/components/global/Upload.vue